import { FormikProps, getIn } from "formik";

export const hasErrors = (fieldName: string, form: FormikProps<any>): boolean => {
    return !!(
      getIn(form.errors, fieldName) &&
      (getIn(form.touched, fieldName) || form.submitCount > 0)
    );
  };
  